import { render, staticRenderFns } from "./AdminSideNav.vue?vue&type=template&id=50153ba4&scoped=true&"
import script from "./AdminSideNav.vue?vue&type=script&lang=ts&"
export * from "./AdminSideNav.vue?vue&type=script&lang=ts&"
import style0 from "./AdminSideNav.vue?vue&type=style&index=0&id=50153ba4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50153ba4",
  null
  
)

export default component.exports